import { useEffect, useState } from "react";
import { useIntl } from "react-intl"
import CreatableSelect from 'react-select/creatable';

export const KeywordsFilter = (props) => {
  const onChange = props.onChange? props.onChange: () => {}

  const intl = useIntl()
  const [keywords, setKeywords] = useState<any>([])

  useEffect(() => {
    onChange(keywords)
  }, [keywords])
  return (
    <>
      <div className='row mb-3'>
        <div className='col-12'>
          <label htmlFor='date_range' className='fw-bold fs-6'>
            {intl.formatMessage({
              id: 'GENERIC.INSERT_KEYWORDS',
            })}
          </label>
          
        
        <div className='col-12'>
          <CreatableSelect 
          
          isMulti
          formatCreateLabel={(inputValue) => `keyword: ${inputValue}`}
          value={keywords}
          onChange={(selectedOption) => {
            setKeywords(selectedOption)
            console.log(selectedOption) 
          }}

          />
        </div>
      </div>
      </div>
    </>
  )
}
